// =============================================================================
// src/config/index.js
// Every REACT_APP_* read lives here (set at build time). Import from this file.
// On/off switches are not env: they live in ./features.js.
// ZS-only values go in ./zs_config.js and win over the env on ZS.
// =============================================================================

import { DEPLOYMENT } from './deployment';
import ZS_CONFIG from './zs_config';

const ZS = DEPLOYMENT === 'zs' ? ZS_CONFIG : {};
const zs = (name, value) =>
  Object.prototype.hasOwnProperty.call(ZS, name) ? ZS[name] : value;

// Blank, spaces, or "undefined"/"null" left by shell templating = unset, so a
// bad build arg falls back like a missing one instead of breaking the app.
const read = (value) => {
  const v = (value || '').trim();
  return v && v !== 'undefined' && v !== 'null' ? v : undefined;
};

// Trailing slashes dropped: callers append paths like `${API_URL}/api/...`.
const readUrl = (value) => read(value)?.replace(/\/+$/, '');

// Unset = same origin, so one image works behind any customer hostname.
export const API_URL = zs(
  'API_URL',
  readUrl(process.env.REACT_APP_API_URL) || window.location.origin,
);
export const NOTIFICATION_SERVER_URL = zs(
  'NOTIFICATION_SERVER_URL',
  readUrl(process.env.REACT_APP_NOTIFICATION_SERVER_URL) ||
    window.location.origin,
);

// Teams App ID from the manifest. Unset in builds that don't ship the Teams
// app; inside Teams those builds switch pages with the in-app router instead.
export const TEAMS_APP_ID = zs(
  'TEAMS_APP_ID',
  read(process.env.REACT_APP_TEAMS_APP_ID),
);

// Google Drive picker; set per deployment (the picker fails without them).
export const GOOGLE_CLIENT_ID = zs(
  'GOOGLE_CLIENT_ID',
  read(process.env.REACT_APP_GOOGLE_CLIENT_ID),
);
export const GOOGLE_API_KEY = zs(
  'GOOGLE_API_KEY',
  read(process.env.REACT_APP_GOOGLE_API_KEY),
);

// Microsoft Clarity analytics; unset = Clarity is off.
export const CLARITY_PROJECT_ID = zs(
  'CLARITY_PROJECT_ID',
  read(process.env.REACT_APP_CLARITY_PROJECT_ID),
);
